import { extractPackDisplayName } from "utils/yaml";
import { arrayMove } from "@dnd-kit/sortable";

export function PROFILE_BUILDER_INIT(
  nextState,
  {
    guid,
    layers,
    isEditMode,
    isClusterProfileUsed,
    cloudType = "",
    profileUid,
    isProfileAssociatedToTemplate = false,
    variables,
    profileType,
  }
) {
  nextState[guid] = {
    guid: guid,
    layers,
    isEditMode,
    profileUid,
    isClusterProfileUsed,
    initialLayers: [...layers],
    packLayers: [],
    draftLayers: [],
    selectedLayer: null,
    layerClone: null,
    isEditorExpanded: false,
    showEditor: false,
    formType: null,
    openedEditor: "",
    expandedPack: null,
    appliedManifests: [],
    currentAttachedManifestGuid: null,
    isImportClusterLayerExpanded: false,
    isProfileAssociatedToTemplate,
    errors: {},
    variables: variables || [],
    variablesOrderMode: false,
    packsEditor: {
      selectedGuid: null,
      currentName: "",
    },
    resolvedValues: null,
    helmRepoUid: null,
    packRepoUid: null,
    previousVersionData: null,
    displayVersionChangeDiff: false,
    cloudType,
    isPacksSearchMode: false,
    profileType,
    packsSearch: {
      showRegistrySelectModal: false,
      registryModalPackData: null,
      registryModalSelectedValue: null,
      searchIsDisabled: false,
    },
  };
}

export function PROFILE_BUILDER_DESTROY(nextState, { guid }) {
  nextState[guid] = null;
}

export function PROFILE_BUILDER_SELECT_LAYER(
  nextState,
  { guid, layer, openedEditor, isEditorExpanded, isPacksSearchMode }
) {
  nextState[guid].selectedLayer = layer.guid;
  nextState[guid].layerClone = layer;
  nextState[guid].openedEditor = openedEditor;
  nextState[guid].isEditorExpanded = isEditorExpanded;
  nextState[guid].isPacksSearchMode = isPacksSearchMode;
  nextState[guid].packsSearch.showRegistrySelectModal = false;
  nextState[guid].packsSearch.searchIsDisabled = false;
}

export function PROFILE_BUILDER_UNSELECT_LAYER(nextState, { guid }) {
  nextState[guid].errors = {};
  nextState[guid].selectedLayer = null;
  nextState[guid].layerClone = null;
}

export function PROFILE_BUILDER_SUBMIT_DRAFT_LAYERS(
  nextState,
  { guid },
  state
) {
  nextState[guid].draftLayers = [];
  nextState[guid].selectedLayer = null;
  nextState[guid].layers = state[guid].layers
    .filter((layer) => layer.type !== "new")
    .map((layer) => ({
      ...layer,
      isDraft: false,
    }));
  nextState[guid].formType = null;
  nextState[guid].isEditorExpanded = false;
  nextState[guid].isPacksSearchMode = false;
  nextState[guid].openedEditor = "";
  nextState[guid].packLayers = [];
  nextState[guid].currentAttachedManifestGuid = null;
  nextState[guid].layerClone = null;
  nextState[guid].packsSearch.showRegistrySelectModal = false;
  nextState[guid].packsSearch.searchIsDisabled = false;
}

export function PROFILE_BUILDER_EDITOR_TOGGLE(nextState, { guid }, state) {
  const showEditor = !state[guid].showEditor;
  nextState[guid].showEditor = showEditor;
}

export function PROFILE_BUILDER_SHOW_PACKS_SEARCH(nextState, { guid }) {
  nextState[guid].isPacksSearchMode = true;
  nextState[guid].packsSearch.showRegistrySelectModal = false;
  nextState[guid].packsSearch.searchIsDisabled = false;
}

export function PROFILE_BUILDER_PACKS_SEARCH_SET_DISABLED(nextState, { guid }) {
  nextState[guid].packsSearch.searchIsDisabled = true;
}

export function PROFILE_BUILDER_HIDE_PACKS_SEARCH(nextState, { guid }) {
  nextState[guid].isPacksSearchMode = false;
  nextState[guid].packsSearch.showRegistrySelectModal = false;
  nextState[guid].packsSearch.searchIsDisabled = false;
}

export function PROFILE_BUILDER_PACKS_SEARCH_SHOW_REGISTRY_SELECT(
  nextState,
  { guid, pack }
) {
  nextState[guid].packsSearch.showRegistrySelectModal = true;
  nextState[guid].packsSearch.registryModalPackData = pack;
  nextState[guid].packsSearch.registryModalSelectedValue = null;
}

export function PROFILE_BUILDER_PACKS_SEARCH_SELECT_REGISTRY(
  nextState,
  { guid, registryUid }
) {
  nextState[guid].packsSearch.registryModalSelectedValue = registryUid;
}

export function PROFILE_BUILDER_PACKS_SEARCH_HIDE_REGISTRY_SELECT(
  nextState,
  { guid }
) {
  nextState[guid].packsSearch.showRegistrySelectModal = false;
  nextState[guid].packsSearch.registryModalPackData = null;
  nextState[guid].packsSearch.registryModalSelectedValue = null;
}

export function PROFILE_BUILDER_ADD_UIDS_TO_DRAFT_LAYERS(
  nextState,
  { guid, layers }
) {
  nextState[guid].layers = layers;
}

export function PROFILE_BUILDER_UPDATE_LAYER_REPOS(
  nextState,
  { guid, expandedPack, isImportClusterLayerExpanded }
) {
  nextState[guid].expandedPack = expandedPack;
  nextState[guid].isImportClusterLayerExpanded = isImportClusterLayerExpanded;
}

export function PROFILE_BUILDER_PACK_VALUES_TOGGLE(
  nextState,
  { guid, sectionName, isEditorExpanded }
) {
  nextState[guid].openedEditor = sectionName;
  nextState[guid].isEditorExpanded = isEditorExpanded;
  nextState[guid].currentAttachedManifestGuid = null;
}

export function PROFILE_BUILDER_TOGGLE_ADD_FORM(nextState, { guid, formType }) {
  nextState[guid].formType = formType;
  nextState[guid].isEditorExpanded = false;
  nextState[guid].isPacksSearchMode = false;
  nextState[guid].packsSearch.searchIsDisabled = false;
  nextState[guid].packsSearch.showRegistrySelectModal = false;
  nextState[guid].currentAttachedManifestGuid = null;
  nextState[guid].openedEditor = "";
}
export function PROFILE_BUILDER_TOGGLE_DRAFT_LAYERS(
  nextState,
  { guid, layerGuid, value },
  state
) {
  if (value) {
    nextState[guid].layers.push(
      state[guid].packLayers.find((layer) => layer.guid === layerGuid)
    );
    nextState[guid].draftLayers.push(layerGuid);
    return;
  }

  nextState[guid].layers = state[guid].layers.filter(
    (layer) => layer.guid !== layerGuid
  );
  nextState[guid].draftLayers.filter((layer) => layer.guid !== layerGuid);
}

export function PROFILE_BUILDER_ADD_DRAFT_LAYER(
  nextState,
  { guid, layer, isEditorExpanded, isPacksSearchMode },
  state
) {
  nextState[guid].layers.push(layer);
  nextState[guid].draftLayers = [...state[guid].draftLayers, layer.guid];
  nextState[guid].isEditorExpanded = isEditorExpanded;
  nextState[guid].isPacksSearchMode = isPacksSearchMode;
  nextState[guid].packsSearch.searchIsDisabled = false;
  nextState[guid].packsSearch.showRegistrySelectModal = false;
}

export function PROFILE_BUILDER_ADD_DRAFT_LAYERS(nextState, { guid, layers }) {
  nextState[guid].layers.push(
    ...layers.filter((layer) => layer.matchedRegistries.length === 1)
  );
  nextState[guid].packLayers = layers;
  nextState[guid].draftLayers = layers.reduce(
    (acc, layer) => [...acc, layer.guid],
    []
  );
}

export function PROFILE_BUILDER_UPDATE_EXPANDED_PACK_REPOSITORY(
  nextState,
  { guid, newRegistry },
  state
) {
  const { expandedPack, packLayers } = state[guid];
  const registryMetadata = {
    name: newRegistry.metadata.name,
    uid: newRegistry.metadata.uid,
  };
  const updatedPackLayers = packLayers.map((layer) => {
    if (layer.guid === expandedPack.guid) {
      return {
        ...layer,
        matchedRegistries: [...layer.matchedRegistries, registryMetadata],
      };
    }
    return layer;
  });

  nextState[guid].expandedPack = {
    ...expandedPack,
    matchedRegistries: [...expandedPack.matchedRegistries, registryMetadata],
  };
  nextState[guid].packLayers = updatedPackLayers;
}

export function PROFILE_BUILDER_ADD_REPO_TO_EXPANDED_LAYER(
  nextState,
  { guid, registryUid },
  state
) {
  nextState[guid].packLayers = state[guid].packLayers.map((layer) => {
    if (layer.guid !== state[guid].expandedPack.guid) {
      return layer;
    }

    return {
      ...layer,
      matchedRegistries: [registryUid],
      config: {
        ...layer.config,
        registryUid,
      },
    };
  });
  nextState[guid].isImportClusterLayerExpanded = false;
  nextState[guid].expandedPack = null;
}

export function PROFILE_BUILDER_REMOVE_LAYER(nextState, { guid }, state) {
  const layers = state[guid].layers;
  const selectedLayer = state[guid].selectedLayer;
  nextState[guid].layers = layers.filter(
    (layer) => layer.guid !== selectedLayer
  );
  delete nextState[guid].errors[selectedLayer];
}

export function PROFILE_BUILDER_CLEAR_IMPORT_CLUSTER(
  nextState,
  { guid },
  state
) {
  nextState[guid].layers = state[guid].layers.filter(
    (layer) => !state[guid].draftLayers.includes(layer.guid)
  );
  nextState[guid].draftLayers = [];
  nextState[guid].packLayers = [];
  nextState[guid].isImportClusterLayerExpanded = false;
}

export function PROFILE_BUILDER_UPDATE_LAYER(
  nextState,
  { guid, layer },
  state
) {
  const layers = state[guid].layers;
  const selectedLayer = state[guid].selectedLayer;
  const draftLayer = state[guid].draftLayers?.[0];

  nextState[guid].layers = layers.map((currentLayer) => {
    if (
      currentLayer.guid === selectedLayer ||
      currentLayer.guid === draftLayer
    ) {
      return {
        ...currentLayer,
        ...layer,
      };
    }
    return currentLayer;
  });
}

export function PROFILE_BUILDER_UPDATE_LAYER_CONFIG(
  nextState,
  { guid, layer },
  state
) {
  const layers = state[guid].layers;
  nextState[guid].layers = layers.map((currentLayer) => {
    if (currentLayer.guid === layer.guid) {
      return {
        ...currentLayer,
        config: layer.config,
      };
    }
    return currentLayer;
  });
}

export function PROFILE_BUILDER_EDITOR_SELECT_LAYER(
  nextState,
  { guid, layerGuid }
) {
  nextState[guid].packsEditor.selectedGuid = layerGuid;
}

export function PROFILE_BUILDER_EDITOR_SET_NAME(nextState, { guid, name }) {
  nextState[guid].packsEditor.currentName = name;
}

export function PROFILE_BUILDER_APPLY_EDITOR_CHANGES(
  nextState,
  { guid, packsData },
  state
) {
  const layers = state[guid].layers;

  nextState[guid].layers = layers.map((layer) => {
    const packData = packsData[layer.guid];
    const values = packData ? packData.values : layer.config?.values;

    if (!layer.config) {
      return {
        ...layer,
      };
    }

    return {
      ...layer,
      config: {
        ...layer.config,
        values,
        selectedPresets: packData
          ? packData.presets
          : layer.config?.selectedPresets,
        manifests: packData?.manifests
          ? [...packData.manifests]
          : [...(layer.config?.manifests || [])],
        displayName: extractPackDisplayName({
          values,
          displayName: layer.config?.displayName,
        }),
      },
    };
  });
}

export function TOGGLE_ATTACHED_MANIFEST_EDITOR(
  nextState,
  {
    guid,
    manifestGuid,
    openedEditor,
    isEditorExpanded,
    isTemplatedManifest,
    editorType,
  }
) {
  nextState[guid].currentAttachedManifestGuid = manifestGuid;
  nextState[guid].openedEditor = openedEditor;
  nextState[guid].isEditorExpanded = isEditorExpanded;
  nextState[guid].isTemplateManifest = isTemplatedManifest || false;
  nextState[guid].editorType = editorType;
}

export function TOGGLE_NEW_MANIFEST_EDITOR(
  nextState,
  {
    guid,
    isEditorExpanded,
    currentAttachedManifestGuid,
    isTemplateManifest,
    openedEditor,
  }
) {
  nextState[guid].openedEditor = openedEditor;
  nextState[guid].isEditorExpanded = isEditorExpanded;
  nextState[guid].currentAttachedManifestGuid = currentAttachedManifestGuid;
  nextState[guid].isTemplateManifest = isTemplateManifest;
}

export function APPLY_MANIFEST_NAME(
  nextState,
  { manifestGuid, guid, isEditorExpanded }
) {
  nextState[guid].appliedManifests.push(manifestGuid);
  nextState[guid].isEditorExpanded = isEditorExpanded;
}

export function FORM_LOAD_SUCCESS(nextState, { module, result }) {
  if (module === "layerPack") {
    nextState[result.profileModuleGuid].appliedManifests = result.manifests.map(
      (manifest) => manifest.guid
    );
  }
}

export function PROFILE_BUILDER_UPDATE_PACK_ERROR(
  nextState,
  { guid, packGuid, error },
  state
) {
  const packErrors = state[guid].errors[packGuid] || [];
  const indexOfError = packErrors.findIndex(
    (currentError) =>
      currentError.guid === error.guid && error.field === currentError.field
  );

  if (indexOfError !== -1) {
    nextState[guid].errors[packGuid][indexOfError] = error;
  } else {
    nextState[guid].errors[packGuid] = [...packErrors, error];
  }
}

export function VALIDATE_PROFILE_PACKS_REQUEST(nextState, { guid, result }) {
  nextState[guid].backendErrors = null;
}

export function VALIDATE_PROFILE_PACKS_SUCCESS(nextState, { guid, result }) {
  nextState[guid].backendErrors = result?.packs?.results || null;
}

export function PROFILE_BUILDER_UPDATE_PACKS_ERRORS(
  nextState,
  { guid, errors }
) {
  nextState[guid].errors = errors || {};
}

export function PROFILE_BUILDER_UPDATE_RESOLVED_VALUES(
  nextState,
  { guid, resolvedValues }
) {
  nextState[guid].resolvedValues = resolvedValues;
}

export function PROFILE_BUILDER_SET_REPOSITORY(
  nextState,
  { guid, repositoryUid, packType }
) {
  if (!packType) {
    return;
  }
  if (packType === "helmChart") {
    nextState[guid].helmRepoUid = repositoryUid;
  } else {
    nextState[guid].packRepoUid = repositoryUid;
  }
}

export function PROFILE_BUILDER_ADD_PACK_VERSION_NORMALIZATION(
  nextState,
  { guid, entities },
  state
) {
  if (!entities?.packVersion) {
    return;
  }
  let layers = state[guid].layers;

  Object.keys(entities.packVersion).forEach((packVersionGuid) => {
    const { packUid, tag } = entities.packVersion[packVersionGuid];
    layers = layers.map((layer) => {
      if (
        layer.config?.packUid === packUid &&
        layer.config?.tag === tag &&
        !layer.config?.packVersionGuid
      ) {
        return {
          ...layer,
          config: {
            ...layer.config,
            packVersionGuid,
          },
        };
      }
      return layer;
    });
  });
  nextState[guid].layers = layers;
}

export function APPLY_MANIFESTS(
  nextState,
  { guid, appliedManifests, currentAttachedManifestGuid }
) {
  nextState[guid].appliedManifests = appliedManifests;
  nextState[guid].isEditorExpanded = !!appliedManifests.length;
  nextState[guid].currentAttachedManifestGuid = appliedManifests.length
    ? currentAttachedManifestGuid
    : null;
}

export function PROFILE_BUILDER_SET_BASE_IS_CONFIGURED(
  nextState,
  { guid, isProfileBaseConfigured }
) {
  nextState[guid].isProfileBaseConfigured = isProfileBaseConfigured;
}

export function PROFILE_BUILDER_ADD_CONTENT_TO_LAYER_MANIFESTS(
  nextState,
  { guid, layer },
  state
) {
  const initialLayers = state[guid].initialLayers;
  const layerGuid = layer.guid;

  const initialLayerIndex = initialLayers.findIndex(
    (initialLayer) => initialLayer.guid === layerGuid
  );

  if (initialLayerIndex !== -1) {
    nextState[guid].initialLayers[initialLayerIndex] = layer;
  }

  const layerIndex = nextState[guid].layers.findIndex(
    (layer) => layer.guid === layerGuid
  );
  if (layerIndex !== -1) {
    nextState[guid].layers[layerIndex] = layer;
    nextState[guid].layerClone = layer;
  }
}

export function PROFILE_BUILDER_VERSION_CHANGE(
  nextState,
  { guid, previousVersionData }
) {
  nextState[guid].displayVersionChangeDiff = true;
  nextState[guid].previousVersionData = previousVersionData;
}

export function PROFILE_BUILDER_RESOLVE_NEW_VERSION_CHANGES(
  nextState,
  { guid }
) {
  nextState[guid].displayVersionChangeDiff = false;
  nextState[guid].previousVersionData = null;
}

export function PROFILE_BUILDER_UPSERT_VARIABLE(nextState, { guid, data }) {
  const existingVariable = nextState[guid].variables.find(
    (variable) => variable.guid === data.guid
  );

  if (existingVariable) {
    Object.assign(existingVariable, data);
    return;
  }

  nextState[guid].variables.push(data);
}

export function PROFILE_BUILDER_REMOVE_VARIABLE(nextState, { guid, varGuid }) {
  const existingVariable = nextState[guid].variables.findIndex(
    (variable) => variable.guid === varGuid
  );

  if (existingVariable === -1) {
    return;
  }

  nextState[guid].variables.splice(existingVariable, 1);
}

export function PROFILE_BUILDER_UPDATE_VARIABLES_ORDER(
  nextState,
  { guid, newIndex, oldIndex }
) {
  nextState[guid].variables = arrayMove(
    nextState[guid].variables,
    oldIndex,
    newIndex
  );
}

export function PROFILE_BUILDER_SET_VARIABLES_ORDER_MODE(
  nextState,
  { guid, value }
) {
  nextState[guid].variablesOrderMode = value;
}
